import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import RightTit from '../rightTit';

class HotNews extends React.PureComponent {
    render() {
        const { content } = this.props;
        const creatList = () => (
            <ul>
                {content.map((item, index) => {
                    return (
                        <li key={index} className="clearfix">
                            <img className={styles.img} src={item.src} />
                            <div className={styles.txt}>
                                <p className={styles.tit}>{item.title}</p>
                                <p className={styles.description}>{item.description}</p>
                            </div>
                        </li>
                    );
                })}
            </ul>
        );

        return (
            <div className={styles.weixin}>
                <RightTit txt="官方微信" />
                <Chip id="50164" type="struct" title="官方微信" groupName="rightContent" content={content}>
                    <div className={styles.list}>{creatList()}</div>
                </Chip>
            </div>
        );
    }
}

HotNews.propTypes = { content: PropTypes.array };
HotNews.defaultProps = {};

export default errorBoundary(HotNews);
